import { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import { MdArrowForwardIos, MdDelete } from "react-icons/md";
import { MdOutlineSportsCricket } from "react-icons/md";
import { MdHistory } from "react-icons/md";
import { MdOutlinePayments } from "react-icons/md";
import { MdOutlinePassword } from "react-icons/md";
import { MdOutlinePrivacyTip } from "react-icons/md";
import { MdOutlineHelpCenter } from "react-icons/md";
import { IoShareSocialSharp } from "react-icons/io5";
import { AiOutlineDelete } from "react-icons/ai";
import Button from "../ui/Button";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { APP_CONSTANT, roles, USER_TYPE, USERS_LIST } from "helper/constant";
import ChangePassword from "component/auth/ChangePassword";
import CommonModal from "component/ui/CommonModal";
import { useDispatch, useSelector } from "react-redux";
import { deleteUserAccount } from "store/slice/profile";
import FullPageLoader from "component/ui/fullPageLoader";
import { LogOut, Trash } from "lucide-react";
import ShareModal from "pages/profile/sharePlaymatez";
import ActionDropdown from "component/ui/ActionDropdown";
import { useLoginData } from "component/common/loginData";

export default function SideBar({ open, setOpen }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = useLoginData();
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const { isDeleteAccountLoading, userProfileData } = useSelector((state) => state.profile);
  const [shareOpen, setShareOpen] = useState(false);
  const [shareUrl, setShareUrl] = useState("https://example.com");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [logoutType, setLogoutType] = useState("");
  const handlePasswordUpdate = (formData) => {
    console.log("Submitting password change:", formData);
    setIsPasswordModalOpen(false);
  };
  useEffect(() => {
    const body = document.body;

    if (open) {
      const scrollY = window.scrollY;

      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.width = "100%";
    } else {
      const scrollY = body.style.top;

      body.style.position = "";
      body.style.top = "";
      body.style.width = "";

      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    }

    return () => {
      body.style.position = "";
      body.style.top = "";
      body.style.width = "";
    };
  }, [open]);

  const redirectToEdit = () => {
    navigate("/profile-edit");
    setOpen(false);
  };

  const handleLogout = () => {
    if (logoutType == "all") {
      secureLocalStorage.clear();
      navigate("/login");
      window.location.reload();
      return;
    }
    secureLocalStorage.removeItem(process.env.REACT_APP_TOKEN_STORAGE_KEY);
    secureLocalStorage.removeItem(process.env.REACT_APP_USER_STORAGE_KEY);
    const userList = USERS_LIST?.filter(
      (item) => item?.data?.id != userData?.id
    );
    secureLocalStorage.setItem(process.env.REACT_APP_USERS_LIST_KEY, userList);
    navigate("/login");
    window.location.reload();
  };

  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);
  const [isShowDeleteDialog, setIsDeleteDialog] = useState(false);

  const openLogoutModal = () => {
    setIsLogoutModalOpen(true);
  };

  const setting_menu = [
    {
      label: "Rating",
      icon: <FaStar color="orange" size={20} />,
      id: 1,
    },
    {
      label: "Venue Operation",
      icon: <MdOutlineSportsCricket size={20} />,
      id: 2,
    },
    {
      label: "Booking History",
      icon: <MdHistory color="#E119FA" size={20} />,
      id: 3,
    },
    {
      label: "Payment Methods",
      icon: <MdOutlinePayments color="red" size={20} />,
      id: 4,
    },
    {
      label: "Change password",
      icon: <MdOutlinePassword color="#01b5f4" size={20} />,
      id: 5,
    },
    {
      label: "Privacy Policy",
      icon: <MdOutlinePrivacyTip color="#149a5b" size={20} />,
      id: 6,
    },
    {
      label: "Help",
      icon: <MdOutlineHelpCenter color="#276CF5" size={20} />,
      id: 7,
    },
    {
      label: "Share PlayMatez",
      icon: <IoShareSocialSharp color="#401582" size={20} />,
      id: 8,
    },
    {
      label: "Delete Account",
      icon: <AiOutlineDelete color="red" size={20} />,
      id: 9,
    },
  ];

  const handleDelete = () => {
    dispatch(deleteUserAccount(handleLogout));
  };
  return (
    <>
      {isDeleteAccountLoading && <FullPageLoader />}
      {open && (
        <div
          className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"
          onClick={() => setOpen(false)}
        />
      )}
      <div
        className={`fixed right-0 top-0 z-50 h-full w-full sm:w-96 bg-white shadow-lg transition-transform duration-300
          ${open ? "translate-x-0" : "translate-x-full"}
        `}
      >
        <button
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors z-10"
          aria-label="Close"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>

        {/* Profile Section (PRESERVED) */}
        <div className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
          {" "}
          <div className="relative flex items-center gap-4 py-10 px-6">
            {/* Avatar */}
            <div className="relative group">
              <div
                style={{
                  backgroundImage:
                    userData?.venueImageUrl?.length > 0
                      ? `url("${userData?.venueImageUrl?.length > 0 &&
                      userData?.venueImageUrl[0]
                      }")`
                      : "linear-gradient(to bottom right, #3B82F6, #9333EA)",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                className="h-14 w-14 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full font-bold text-2xl flex items-center justify-center text-white shadow-xl ring-4 ring-white/10 transition-transform "
              >
                {userData?.venueImageUrl?.length > 0
                  ? ""
                  : userData?.name && userData?.name[0]?.toUpperCase()}
              </div>
            </div>

            {/* Profile Info */}
            <div className="flex-1">
              <div className="flex items-center gap-2 ">
                <h2 className="text-white text-lg font-semibold w-24 truncate capitalize">
                  {userData?.name}
                </h2>
                {/* The Dropdown Container */}
                <div className="relative">
                  <ActionDropdown
                    isOpen={isDropdownOpen}
                    setIsOpen={setIsDropdownOpen}
                  />
                </div>
              </div>
              <p className="text-blue-300 text-sm font-medium mb-2 flex items-center gap-2">
                <span className="inline-block w-2 h-2 bg-blue-400 rounded-full"></span>
                {USER_TYPE[userData?.userType]}
              </p>
              <Button size="xs" onClick={redirectToEdit}>
                Edit Profile
              </Button>
            </div>
          </div>
        </div>

        <div
          className="p-2 overflow-auto md:pb-10 pb-32 thin-scrollbar"
          style={{ height: "68vh" }}
        >
          {setting_menu?.map((item) => {
            return (userProfileData?.data?.userType == roles?.CLUB && item?.id != 2) || userProfileData?.data?.userType == roles?.VENUE ? (
              <div
                key={item?.id}
                className="grid grid-cols-7 py-2 cursor-pointer relative"
                onClick={() => {
                  if (item?.id == 1) {
                    navigate("/rating");
                  }
                  if (item?.id == 2) {
                    navigate("/venue-operations");
                  }
                  if (item?.id == 3) {
                    navigate("/booking-history");
                  }
                  if (item?.id == 4) {
                    navigate("/payment-methods");
                  }
                  if (item?.id == 5) {
                    setIsPasswordModalOpen(true);
                  }
                  if (item?.id == 6) {
                    window.open(APP_CONSTANT?.PRIVACY_POLICY_URL, "_blank");
                  }
                  if (item?.id == 7) {
                    window.open(APP_CONSTANT?.HELP_URL, "_blank");
                  }
                  if (item?.id == 8) {
                    setShareOpen(true);
                  }
                  if (item?.id == 9) {
                    setIsDeleteDialog(true);
                  }
                  setOpen(false);
                }}
              >
                <div className="bg-[#2bace238] text-black w-10 h-10 rounded-full flex items-center justify-center">
                  {item?.icon}
                </div>
                <div className="col-span-5 text-black font-semibold flex items-center">
                  {item?.label}
                </div>
                <MdArrowForwardIos color="gray" size={20} />
              </div>
            ) : '';
          })}
        </div>

        {/* Logout (PRESERVED) */}
        <div className="h-30 bg-[#E8E6E6] absolute bottom-0 right-0 left-0 md:pb-0 pb-0">
          <div className="grid grid-cols-2 p-3 gap-3">
            <div>
              <Button
                onClick={() => {
                  openLogoutModal();
                  setLogoutType("");
                }}
                children="Logout"
                fullWidth
                className="md"
              />
            </div>
            <div>
              <Button
                onClick={() => {
                  openLogoutModal();
                  setLogoutType("all");
                }}
                children="Logout All"
                fullWidth
              />
            </div>
          </div>
        </div>
      </div>

      {/*ChangePassword MODAL */}
      {isPasswordModalOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100]"
          onClick={() => setIsPasswordModalOpen(false)}
        >
          <div onClick={(e) => e.stopPropagation()}>
            <ChangePassword
              onCancel={() => setIsPasswordModalOpen(false)}
              onSubmit={handlePasswordUpdate}
              setIsPasswordModalOpen={setIsPasswordModalOpen}
            />
          </div>
        </div>
      )}

      {shareOpen && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[100]"
          onClick={() => setShareOpen(false)}
        >
          <ShareModal
            isOpen={shareOpen}
            onClose={() => setShareOpen(false)}
            shareUrl={shareUrl}
            setShareUrl={setShareUrl}
          />
        </div>
      )}

      {/* Logout modal */}
      {isLogoutModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]"
          onClick={() => setIsPasswordModalOpen(false)}
        >
          <CommonModal
            icon={<LogOut />}
            isOpen={isLogoutModalOpen}
            title="Confirm Logout"
            message={`Are you sure you want to log out of your ${logoutType == "all" ? "all accounts" : "account"
              }?`}
            confirmButtonText="Yes"
            cancleButtonText="No"
            onConfirm={handleLogout}
            onCancel={() => setIsLogoutModalOpen(false)}
          />
        </div>
      )}

      {/* Logout modal */}
      {isShowDeleteDialog && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]"
          onClick={() => setIsDeleteDialog(false)}
        >
          <CommonModal
            icon={<Trash />}
            isOpen={isShowDeleteDialog}
            title="Delete Account"
            message="Are you sure you want to delete your account permanently?"
            confirmButtonText="Delete"
            onConfirm={handleDelete}
            onCancel={() => setIsDeleteDialog(false)}
          />
        </div>
      )}
    </>
  );
}
